import { BaseEntity } from "yt-ng-framework";

export class Valuta extends BaseEntity{
    constructor(){
        super();
    }

    Sifra:string = null;
    ISOAlpha3Code:string = null;
    Naziv:string = null;

    Deserialize(input:any){
        this.ID=input.ID;
        this.Sifra=input.Sifra;
        this.ISOAlpha3Code=input.ISOAlpha3Code;
        this.Naziv=input.Naziv;
        return this;
    }

    Serialize(input:Valuta){
        return input;
    }
}